/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';
// @ts-ignore
import { SupplementItemApiDto } from '../model/supplement-item.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { SupplementsControllerApiServiceInterface } from './supplements-controller.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class SupplementsControllerApiService extends BaseService implements SupplementsControllerApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param schoolId
   * @param courseIds
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param accommodationIds
   * @param tripStartDate
   * @param tripEndDate
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findSupplementsByCoursesAndAccommodations(
    schoolId: number,
    courseIds: Array<number>,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    accommodationIds?: Array<number>,
    tripStartDate?: string,
    tripEndDate?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<SupplementItemApiDto>>;
  public findSupplementsByCoursesAndAccommodations(
    schoolId: number,
    courseIds: Array<number>,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    accommodationIds?: Array<number>,
    tripStartDate?: string,
    tripEndDate?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<SupplementItemApiDto>>>;
  public findSupplementsByCoursesAndAccommodations(
    schoolId: number,
    courseIds: Array<number>,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    accommodationIds?: Array<number>,
    tripStartDate?: string,
    tripEndDate?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<SupplementItemApiDto>>>;
  public findSupplementsByCoursesAndAccommodations(
    schoolId: number,
    courseIds: Array<number>,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    accommodationIds?: Array<number>,
    tripStartDate?: string,
    tripEndDate?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (schoolId === null || schoolId === undefined) {
      throw new Error('Required parameter schoolId was null or undefined when calling findSupplementsByCoursesAndAccommodations.');
    }
    if (courseIds === null || courseIds === undefined) {
      throw new Error('Required parameter courseIds was null or undefined when calling findSupplementsByCoursesAndAccommodations.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling findSupplementsByCoursesAndAccommodations.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling findSupplementsByCoursesAndAccommodations.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>schoolId, 'schoolId');
    if (courseIds) {
      courseIds.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'courseIds');
      });
    }
    if (accommodationIds) {
      accommodationIds.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'accommodationIds');
      });
    }
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>tripStartDate, 'tripStartDate');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>tripEndDate, 'tripEndDate');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v2/supplements`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<SupplementItemApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
